import { PetSellType, PetStatus } from "../Request/AdminRequest";
import { IUserProfileRequest } from "../Request/CustomerRequest";

interface data {
  guestToken: string;
  expiryDate: string;
}

export interface GuestLoginResponse {
  success: boolean;
  message: string;
  data: data;
}

interface CustomerLoginData {
  otp: string;
}

export interface CustomerLoginResponse {
  success: boolean;
  message: string;
  data: CustomerLoginData;
}

interface CustomerOtpData {
  fullName: string;
  email: string;
  role: string;
  walletBalance: number;
  refreshToken: string;
  refreshTokenExpiry: string;
}

export interface CustomerOtpResponse {
  success: boolean;
  message: string;
  data: CustomerOtpData;
}

export interface IUserProfileResponse {
  success: boolean;
  message: string;
  data: IUserProfileRequest;
}

export interface ICreatePetResponse {
  success: boolean;
  message: string;
  data: PetData;
}

export interface PetData {
  id: number;
  currentSubmittedStep: number;
  isFullyFilled: boolean;
  isBasicDetailsComplete: boolean;
  isFoodPreferencesComplete: boolean;
  isHealthConditionsComplete: boolean;
  isGroomingSheddingComplete: boolean;
  petName: string;
  petType: number;
  breed: string;
  gender: number;
  weight: number;
  dateType: string;
  petDate: string; // ISO date string
  furColor: string;
  activityLevel: string;
  personality: string[];
  foodPreferences: string[];
  dietFrequency: string;
  portionSize: string;
  favouriteTreats: string[];
  noKnownIssues: boolean;
  healthConditions: string[];
  requiresVetConsultationAlert: boolean;
  groomingFrequency: string;
  sheddingFrequency: string;
  breedSize: string;
  photoUrl: string;
  isActive: boolean;
}

export interface IAllGetPetsResponse {
  success: boolean;
  message: string;
  data: PetData[];
}

///  ADDRESS ///

export interface IAddressResponse {
  success: boolean;
  message: string;
  data: IAddressData;
}
export interface IGetAddressResponse {
  success: boolean;
  message: string;
  data: IAddressData[];
}

export interface IAddressData {
  id: number;
  fullName: string;
  email: string;
  phoneNumber: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  country: string;
  postalCode: string;
  latitude: number;
  longitude: number;
  addressType: string;
  isDefault: boolean;
  isActive: boolean;
}

export interface Pricing {
  pricingId: number;
  size: string;
  label: string;
  price: number;
  salePrice: number;
}

export interface FilteredPackage {
  packageId: number;
  packageTitle: string;
  packageSubtitle: string;
  description: string;
  durationMinutes: number;
  bufferMinutes: number;
  validForMonths: number;
  includes: string[];
  validFor: string[];
  pricingId: number;
  pricingLabel: string;
  petSize: string;
  originalPrice: number;
  salePrice: number;
  includedBookings?: number;
}

export type IFilteredPackagesResponse = FilteredPackage[];

export interface WorkingDay {
  id: number;
  dayOfWeek: string;
  isEnabled: boolean;
  startTime: string;
  endTime: string;
}

export type IGetWorkingDaysByIdResponse = WorkingDay[];

export interface AddOn {
  addOnId: number;
  name: string;
  description: string;
  imageUrl: string;
  price: number;
  sortOrder: number;
}

export type GetAddOnsResponse = AddOn[];
export interface OfferDate {
  date: string;
  offerTitle: string;
  offerType: string;
  offerValue: number;
  servicePackageId: number | null;
}

export type IGetOffersCalendarResponse = OfferDate[];

export interface IAvailableSlot {
  startTime: string;
  endTime: string;
  isAvailable: boolean;
  bookedCount: number;
  capacity: number;
  occupiedCount?: number;
  RemainingCapacity?: number;
}

export type IAvailableSlotsResponse = IAvailableSlot[];
///// CUSTOMER QUERY ///

export enum QuerySubject {
  GeneralInquiry = 1,
  OrderSupport = 2,
  GroomingServices = 3,
  VendorPartnership = 4,
  PetTaxi = 5,
}

export enum QueryStatus {
  Pending = 1,
  InProgress = 2,
  Resolved = 3,
  Closed = 4,
}
export interface ICustomerQueryResponse {
  id: number;
  subject: QuerySubject;
  orderId?: number | null;
  orderNumber?: string | null;
  message: string;
  attachments: string[];
  status: QueryStatus;
  createdOn: string;
}
/////////////////// job //////////////

export interface IApplyJobResponse {
  value: {
    success: boolean;
    message: string;
    data: boolean;
  };
  formatters: any[];
  contentTypes: any[];
  declaredType: any | null;
  statusCode: number;
}

export interface Job {
  id: number;
  jobTitle: string;
  department: string;
  location: string;
  employmentType: string;
  experienceLevel: string;
  salaryRange: string;
  vacancyCount: number;
  description: string;
  responsibilities: string;
  requirements: string;
  benefits: string;
  lastApplyDate: string;
  isActive: boolean;
  isFeatured: boolean;
}

export interface GetJobsResponse {
  success: boolean;
  message: string;
  data: Job[];
}

export interface IGetActiveJobResponse {
  value: GetJobsResponse;
  formatters: any[];
  contentTypes: any[];
  declaredType: any | null;
  statusCode: number;
}

export interface GetJobIdResponse {
  success: boolean;
  message: string;
  data: Job;
}

export interface IGetAJobByJobIdResponse {
  value: GetJobIdResponse;
  formatters: any[];
  contentTypes: any[];
  declaredType: any | null;
  statusCode: number;
}

export interface JobApplication {
  id: number;
  careerJobId: number;
  jobTitle: string;
  fullName: string;
  email: string;
  phoneNumber: string;
  resumeUrl: string;
  status: string;
}

export interface GetApplicationsResponse {
  success: boolean;
  message: string;
  data: JobApplication[];
}

export interface IGetMyJobApplicationResponse {
  value: GetApplicationsResponse;
  formatters: any[];
  contentTypes: any[];
  declaredType: any | null;
  statusCode: number;
}

////////////////// BLOGS /////////////////

export interface Blog {
  id: number;
  title: string;
  slug: string;
  shortDescription: string;
  description: string;
  thumbnailUrl: string;
  bannerImageUrl: string;
  authorName: string;
  metaTitle: string;
  metaDescription: string;
  viewCount: number;
  isFeatured: boolean;
  isPublished: boolean;
  publishedAt: string;
  createdOn: string;
}

export interface GetActiveBlogs {
  success: boolean;
  message: string;
  data: Blog[];
}

export interface IGetActiveBlogResponse {
  value: GetActiveBlogs;
  formatters: any[];
  contentTypes: any[];
  declaredType: any | null;
  statusCode: number;
}

export interface GetSlugBlog {
  success: boolean;
  message: string;
  data: Blog;
}

export interface IGetBlogBySlugResponse {
  value: GetSlugBlog;
  formatters: any[];
  contentTypes: any[];
  declaredType: any | null;
  statusCode: number;
}

////// SCREEEN  ////
export interface ScreenResponse {
  screenName: string;
  header: Header;
  navigation: NavigationItem[];
  menu: MenuItem[];
  sections: ScreenSection[];
}

export interface Header {
  isLoggedIn: boolean;
  customerId: number;
  customerName: string;
  profileImage: string | null;
  cartCount: number;
}

export interface NavigationItem {
  screenId: number;
  title: string;
  screenName: string;
  displayOrder: number;
}

export interface MenuItem {
  id: number;
  name: string;
  slug: string;
  children: MenuItem[];
}

export interface ScreenSection {
  sectionId: number;
  sectionName: string;
  sectionType: string;
  displayOrder: number;
  isVisible: boolean;
  clientType: number;
  config: SectionConfig | null;
  data: SectionData[];
  layoutType?: string | null;
}

export interface SectionConfig {
  [key: string]: any;
}

export interface SectionData {
  id: number;

  name?: string;
  title?: string;
  subTitle?: string;
  description?: string;

  imageUrl?: string;
  mobileImageUrl?: string;
  thumbnailUrl?: string;
  videoUrl?: string;

  slug?: string;
  type?: string;

  displayOrder?: number;
  isVisible?: boolean;

  action?: SectionAction | null;

  [key: string]: any;
}

export interface SectionAction {
  type: string;
  id: number;
}

//////////////////////  PRODUCTS /////

export interface ProductDetailsResponse {
  success: boolean;
  message: string;
  data: ProductDetails;
}

export interface ProductDetails {
  productId: number;
  name: string;
  shortDescription: string;
  description: string;
  brand: string;
  inStock: boolean;
  images: string[];
  variants: ProductVariant[];
  attributes: ProductAttribute[];
  features: ProductFeature[];
  banner: string | null;
  bundle: BundleProduct | null;
  relatedProducts: RelatedProduct[];
  rating: number;
  totalReviews: number;
  reviews: Review[];
  productFamily: ProductFamily;
  attributeTags: [];
}
export interface BundleProduct {
  bundleId: number;
  name: string;
  bundlePrice: number;
  products: BundleProduct[];
}

export interface BundleProduct {
  productId: number;
  name: string;
  imageUrl: string;
  price: number;
  salePrice: number;
  inStock: boolean;
  productCode: string;
  shortDescription: string | null;
  brandName: string;
  sku: string;
  barcode: string;
  color: string;
  size: string;
  weight: number | null;
  weightUnit: string | null;
  length: number | null;
  width: number | null;
  height: number | null;
  videoUrl: string | null;
  stock: number;
  discountPercentage: number | null;
  images: string[];
  saleStartDate: string | null;
  saleEndDate: string | null;
}

export interface ProductVariant {
  variantId: number;
  sku: string;
  price: number;
  salePrice: number;
  stock: number;
  inStock: boolean;
  color: string;
  size: string;
  weight: number | null;
  weightUnit: string | null;
  length: number | null;
  width: number | null;
  height: number | null;
}

export interface Review {
  customerName: string;
  customerImage?: string | null;
  customerLocation?: string | null;
  reviewImages?: string[];
  rating: number;
  comment?: string;
}

export interface RelatedProduct {
  productId: number;
  name: string;
  imageUrl: string;
  price: number;
  salePrice: number;
  inStock: boolean;
  productCode: string;
  shortDescription: string | null;
  brandName: string | null;
  sku: string;
  barcode: string;
  color: string;
  size: string;
  weight: number | null;
  weightUnit: string | null;
  length: number | null;
  width: number | null;
  height: number | null;
  videoUrl: string;
  stock: number;
  discountPercentage: number | null;
  images: string[];
  saleStartDate: string | null;
  saleEndDate: string | null;
  rating?:number
}

export interface ProductAttribute {
  attributeId?: number;
  name?: string;
  value?: string;
}

export interface ProductFeature {
  feature: string;
}

export interface ProductFamily {
  familyId: number;
  hasFamily: boolean;
  rootProductId: number;
  availableColors: string[];
  availableSizes: string[];
  availableWeights: string[];
  products: ProductFamilyItem[];
}

export interface ProductFamilyItem {
  productId: number;
  name: string;
  description: string | null;
  shortDescription: string | null;
  imageUrl: string;
  videoUrl: string | null;
  price: number;
  salePrice: number | null;
  discountPercentage: number;
  isInStock: boolean;
  stock: number;
  sku: string;
  barcode: string;
  color: string;
  size: string;
  weight: number | null;
  weightUnit: string | null;
  length: number | null;
  width: number | null;
  height: number | null;
  attributes: Record<string, string>;
  isRootProduct: boolean;
  isCurrentProduct: boolean;
  productCode: string;
  sortOrder: number;
  features: string[];
  subscriptionFirstOrderDiscount: number;
  subscriptionRecurringDiscount: number;
  brandId: number;
  brandName: string | null;
  images: string[];
  saleStartDate: string | null;
  saleEndDate: string | null;
  isFreeClaim: boolean;
  freeClaimCartPrice: number | null;
  specifications: any[];
  attributeTags: any[];
}

//// FAQ

export interface GetStatusFAQ {
  success: boolean;
  message: string;
  data: boolean;
}

export interface ICreateFAQResponse {
  value: GetStatusFAQ;
  formatters: any[];
  contentTypes: any[];
  declaredType: any | null;
  statusCode: number;
}

export interface GetAllFaqData {
  id: number;
  category: number;
  categoryName: string;
  question: string;
  answer: string;
  sortOrder: number;
  isActive: boolean;
}

export interface GetFAQByID {
  success: boolean;
  message: string;
  data: GetAllFaqData;
}

export interface GetAllFaq {
  success: boolean;
  message: string;
  data: GetAllFaqData[];
}

export interface IGetByIdFaqResponse {
  value: GetFAQByID;
  formatters: any[];
  contentTypes: any[];
  declaredType: any | null;
  statusCode: number;
}

export interface IGetAllFaqResponse {
  value: GetAllFaq;
  formatters: any[];
  contentTypes: any[];
  declaredType: any | null;
  statusCode: number;
}

//pgae///

export interface GetAllPageData {
  id: number;
  pageType: number;
  pageTypeName: string;
  title: string;
  content: string;
  isActive: boolean;
  createdOn: string;
}

export interface GetByIdPage {
  success: boolean;
  message: string;
  data: GetAllPageData;
}

export interface GetAllPage {
  success: boolean;
  message: string;
  data: GetAllPageData[];
}

export interface IGetByIdPageResponse {
  value: GetByIdPage;
  formatters: any[];
  contentTypes: any[];
  declaredType: any | null;
  statusCode: number;
}

export interface IGetAllPageResponse {
  value: GetAllPage;
  formatters: any[];
  contentTypes: any[];
  declaredType: any | null;
  statusCode: number;
}

export interface IRefreshTokenResponse {
  token: string;
  refreshToken: string;
}

/// process to checkout ///
export interface CreateOrderResponse {
  orderId: number;
  orderNumber: string;

  totalAmount: number;

  gatewayAmount: number;

  requiresOnlinePayment: boolean;

  paymentStatus: string;

  orderStatus: string;
}
///// package purchaasee response //

export interface IMultiPackageUsedresponse {
  orderServiceItemId: number;
  serviceId: number;
  serviceName: string;
  servicePackageId: number;
  packageName: string;
  petProfileId: number;
  petName: string;
  includedBookings: number;
  usedBookings: number;
  remainingBookings: number;
  validForMonths: number;
  purchasedOn: string;
  expiresOn: string;
  customerPackageId:number
}

//// pet taxiprce ///

export interface ICalculatePettaxiPriceResponse {
  distanceKm: number;
  baseFare: number;
  additionalDistanceKm: number;
  additionalCharge: number;
  totalPrice: number;
  dubaiBaseFare:number
  abuDhabiBaseFare:number
  sharjahBaseFare:number
  includedKm:number
  extraKmRate:number
  freeWaitingMinutes:number
}

///// Chekout summry ///

export interface ICheckoutSummaryResponse {
  selectedAddress: ISelectedAddress;
  cart: ISummaryCart;
  availableCoupons: Coupon[];
  rewardPoints: RewardPoints;
  claimableGifts: ClaimableGift[];
  donation: Donation;
  pricing: IPricing;
}

export interface ISelectedAddress {
  addressId: number;
  fullName: string;
  phoneNumber: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  country: string;
  postalCode: string;
}

export interface ISummaryCart {
  productCart: ProductCart;
  petCart: iPetCartResponse;
  serviceCart: IServiceCartResponse;
  grandTotal: number;
  totalItems: number;
}

export interface ProductCart {
  cartId: number;
  userId: number;
  totalItems: number;
  subTotal: number;
  items: ProductCartItem[];
}

export interface ProductCartItem {
  cartItemId: number;
  productVariantId: number;
  productName: string;
  variantName: string;
  imageUrl: string;
  quantity: number;
  unitPrice: number;
  unitSalePrice: number;
  total: number;
  inStock: boolean;
  isPromotional: boolean;
  isFreeItem: boolean;
  isMandatory: boolean;
  isAutoAdded: boolean;
  promotionId: number | null;
}

export interface iPetCartResponse {
  cartId: number;
  userId: number;
  totalItems: number;
  subTotal: number;
  items: PetCartItem[];
}

export interface PetCartItem {
  petCartItemId: number;
  petId: number;
  petName: string;
  breed: string;
  productImage: string;
  purchaseType: string;
  amount: number;
  originalPrice: number;
  bookPrice: number;
  petStatus: string;
}

export interface IServiceCartResponse {
  cartId: number;
  userId: number;
  totalAmount: number;
  totalItems: number;
  items: ServiceCartItem[];
}

export interface ServiceCartItem {
  cartItemId: number;
  serviceId: number;
  serviceName: string;
  servicePackageId: number;
  servicePackageName: string | null;
  servicePackagePricingId: number;
  petProfileId: number;
  petName: string | null;
  bookingDate: string;
  startTime: string;
  endTime: string;
  price: number;
  notes: string;
  serviceDataJson: string;
}

export interface Coupon {
  couponId: number;
  couponCode: string;
  couponName: string;
  description: string;
  discountAmount: number;
  isApplicable: boolean;
}

export interface RewardPoints {
  availablePoints: number;
  appliedPoints: number;
  pointValue: number;
  discountAmount: number;
}

export interface ClaimableGift {
  id?: number;
  name?: string;
  description?: string;
  imageUrl?: string;
}

export interface Donation {
  isEnabled: boolean;
  donationAmount: number;
}

export interface IPricing {
  productTotal: number;
  petTotal: number;
  serviceTotal: number;
  subTotal: number;
  couponDiscount: number;
  rewardPointDiscount: number;
  donationAmount: number;
  deliveryFee: number;
  taxAmount: number;
  totalAmount: number;
}
//Cart
export interface ICartItem {
  cartItemId: number;
  productVariantId: number;
  productName: string;
  variantName: string;
  imageUrl: string;
  quantity: number;
  unitPrice: number;
  unitSalePrice: number;
  total: number;
  inStock: boolean;
  isPromotional: boolean;
  isFreeItem: boolean;
  isMandatory: boolean;
  isAutoAdded: boolean;
  promotionId: number | null;
  isSubscription: boolean | null;
  subscriptionDiscountPercent: number | null;
  interval: number | null;
  billingCycle: string | null;
}

export interface ICartPetItem {
  petCartItemId: number;
  petId: number;
  petName: string;
  breed: string;
  productImage: string;
  purchaseType: string;
  amount: number;
  originalPrice: number;
  bookPrice: number;
  petStatus: string;
}

export interface ICartServiceItem {
  cartItemId: number;
  serviceId: number;
  serviceName: string;
  servicePackageId: number;
  servicePackageName: string;
  servicePackagePricingId: number;
  petProfileId: number;
  petName: string;
  bookingDate: string;
  startTime: string;
  endTime: string;
  price: number;
  notes: string;
  serviceDataJson: string;
}

export interface ICartResponse {
  success: boolean;
  message: string;
  data: ICartItem;
}

export interface ICartData {
  cartId: number;
  userId: number;
  totalItems: number;
  subTotal: number;
  items: ICartItem[];

  bundles: any[];
}

export interface IGetCartResponse {
  success: boolean;
  message: string;
  data: ICartData;
}

export interface IDeleteCartResponse {
  success: boolean;
  message: string;
  data: string;
}

export interface IPetCart {
  cartId: number;
  userId: number;
  totalItems: number;
  subTotal: number;
  items: ICartPetItem[];
}

export interface IServiceCart {
  cartId: number;
  userId: number;
  totalAmount: number;
  totalItems: number;
  items: ICartServiceItem[];
}

export interface IgetUserCartResponse {
  productCart: ICartData;
  petCart: IPetCart;
  serviceCart: IServiceCart;
  grandTotal: number;
  totalItems: number;
}

//// Bundle //

export interface IBundleCartResponse {
  cartId: number;
  userId: number;
  totalItems: number;
  subTotal: number;
  items: ICartBundleItem[];
  bundles: ICartBundle[];
}

export interface ICartBundleItem {
  cartItemId: number;
  productVariantId: number;
  productName: string;
  variantName: string;
  imageUrl: string;
  quantity: number;
  unitPrice: number;
  unitSalePrice: number;
  total: number;
  inStock: boolean;
  isPromotional: boolean;
  isFreeItem: boolean;
  isMandatory: boolean;
  isAutoAdded: boolean;
  promotionId: number | null;
  productId: number;
  isSubscription: boolean;
  billingCycle: number;
  interval: number;
  isBundleItem: boolean;
  productBundleId: number | null;
  bundleUnitPrice: number | null;
  bundleQuantity: number;
}

export interface ICartBundle {
  bundleId: number;
  name: string;
  imageUrl: string;
  bundlePrice: number;
  originalPrice: number;
  savingAmount: number;
  items: ICartItem[];
  totalItems: number;
  total: number;
}

///// payment ///

export interface PaymentSessionResponse {
  success: boolean;
  data: PaymentSessionData;
}

export interface PaymentSessionData {
  success: boolean;
  paymentUrl: string;
  transactionReference: string;
  message: string;
}

export interface PaymentStatusResponse {
  transactionReference: string;
  paymentStatus: string;
  orderStatus: string;
  isPaid: boolean;
}

////////    CHECKOUT /////

export interface CheckoutSummaryResponseDto {
  selectedAddress: CheckoutAddressDto;
  cart: CheckoutCartDto;
  pricing: CheckoutPricingDto;
  availableCoupons: CheckoutCouponDto[];
  rewardPoints: CheckoutRewardPointsDto;
  wallet: CheckoutWalletDto;
  claimableGifts: CheckoutGiftDto[];
  forcedProducts: any[];
  similarProducts: any[];
  recommendedProducts: any[];
  bundleSuggestions: any[];
  sponsoredProducts: any[];
  donation: CheckoutDonationDto;
  validation: CheckoutValidationDto;
  maximumClaimableGifts: number;
  isCouponEnabled?: boolean;
}

export interface CheckoutAddressDto {
  addressId: number;
  fullName: string;
  phoneNumber: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  country: string;
  postalCode: string;
}

export interface CheckoutCartDto {
  productCart: CheckoutProductCartDto;
  petCart: CheckoutPetCartDto;
  serviceCart: CheckoutServiceCartDto;
  grandTotal: number;
  totalItems: number;
}

export interface CheckoutProductCartDto {
  cartId: number;
  userId: number;
  totalItems: number;
  subTotal: number;
  items: CheckoutProductCartItemDto[];
  bundles: IBundle;
}

export interface CheckoutProductCartItemDto {
  cartItemId: number;
  productVariantId: number;
  productName: string;
  variantName: string;
  imageUrl: string;
  quantity: number;
  unitPrice: number;
  unitSalePrice: number;
  total: number;
  inStock: boolean;
  isPromotional: boolean;
  isFreeItem: boolean;
  isMandatory: boolean;
  isAutoAdded: boolean;
  promotionId: number | null;

  // Added
  productId: number;
  isSubscription: boolean;
  billingCycle: number;
  interval: number;
}
export interface IBundle {
  bundleId: number;
  name: string;
  imageUrl: string;
  bundlePrice: number;
  originalPrice: number;
  savingAmount: number;
  items: IBundleItem[];
  totalItems: number;
  total: number;
}

export interface IBundleItem {
  cartItemId: number;
  productVariantId: number;
  productName: string;
  variantName: string;
  imageUrl: string;
  quantity: number;
  unitPrice: number;
  unitSalePrice: number;
  total: number;
  inStock: boolean;
  isPromotional: boolean;
  isFreeItem: boolean;
  isMandatory: boolean;
  isAutoAdded: boolean;
  promotionId: number | null;
  productId: number;
  isSubscription: boolean;
  billingCycle: number;
  interval: number;
  isBundleItem: boolean;
  productBundleId: number | null;
  bundleUnitPrice: number | null;
  bundleQuantity: number;
}

export interface CheckoutPetCartDto {
  cartId: number;
  userId: number;
  totalItems: number;
  subTotal: number;
  items: CheckoutPetCartItemDto[];
}

export interface CheckoutPetCartItemDto {
  petCartItemId: number;
  petId: number;
  petName: string;
  breed: string;
  productImage: string;
  purchaseType: string;
  amount: number;
  originalPrice: number;
  bookPrice: number;
  petStatus: string;
}

export interface CheckoutServiceCartDto {
  cartId: number;
  userId: number;
  totalAmount: number;
  totalItems: number;
  items: CheckoutServiceCartItemDto[];
}

export interface CheckoutServiceCartItemDto {
  cartItemId: number;
  serviceId: number;
  serviceName: string;
  servicePackageId: number;
  servicePackageName: string | null;
  servicePackagePricingId: number;
  petProfileId: number;
  petName: string | null;
  bookingDate: string;
  startTime: string;
  endTime: string;
  price: number;
  notes: string;
  serviceDataJson: string;
}

export interface CheckoutCouponDto {
  couponId: number;
  couponCode: string;
  couponName: string;
  description: string;
  discountAmount: number;
  isApplicable: boolean;
}

export interface CheckoutRewardPointsDto {
  isEnabled: boolean;
  availablePoints: number;
  appliedPoints: number;
  pointValue: number;
  discountAmount: number;

  // Added
  minimumRedeemPoints: number;
  maximumRedeemPoints: number;
  pointsEarnAfterPurchase: number;
  canRedeem: boolean;
}

export interface CheckoutWalletDto {
  isEnabled: boolean;
  availableBalance: number;
  appliedAmount: number;
  maximumRedeemable: number;
  canRedeem: boolean;
  isApplied: boolean;
}

export interface CheckoutGiftDto {
  [key: string]: any;
}

export interface CheckoutDonationDto {
  isEnabled: boolean;
  donationAmount: number;
}

export interface CheckoutPricingDto {
  productTotal: number;
  petTotal: number;
  serviceTotal: number;

  subTotal: number;

  couponDiscount: number;
  rewardPointDiscount: number;
  walletDiscount: number;

  platformFee: number;
  smallOrderFee: number;

  deliveryFee: number;
  donationAmount: number;

  taxAmount: number | 0;

  /**
   * Total before wallet deduction
   */
  totalAmount: number;

  /**
   * Final amount payable after wallet deduction
   */
  gatewayAmount: number;
  remainingAmount?:number;

  /**
   * Savings
   */
  couponSaving: number;
  rewardSaving: number;
  walletSaving: number;
  totalDiscount: number;
}

export interface CheckoutValidationDto {
  canCheckout: boolean;
  messages: string[];
  hasPriceChanged: boolean;
  hasInventoryIssue: boolean;
  hasCouponIssue: boolean;
  hasAddressIssue: boolean;
  hasRewardIssue: boolean;
  hasWalletIssue: boolean;
  hasForcedProductIssue: boolean;
}

///////// PET DETAILS  //////

export interface PetDetails {
  id: number;
  adoptionWhatsAppNumber:string;
  petCode: string;
  microchipId: string;
  category: string;
  petName: string;
  breed: string;
  price: number;
  salePrice: number;
  bookPrice: number;
  productImage: string;
  description: string;
  age: string;
  gender: string;
  tag: string;
  petType: string;
  petStatus: string;
  color: string;
  size: string;
  weight: number;
  isVaccinated: boolean;
  vaccinationDetails: string;
  isKCIRegistered: boolean;
  isFeatured: boolean;
  isActive: boolean;
  subImages: string[];
  videos: PetVideo[];
  categories:any[]
}

export interface PetVideo {
  videoUrl: string;
  thumbnailUrl: string;
}

export interface IPetDashboard {
  Id: number;
  PetCode: string;
  Name: string;
  Breed: string;
  Category: string;
  Gender: string;
  Price: number;
  SalePrice: number;
  ImageUrl: string;
  Tag: string;
  IsFeatured: boolean;
}

export interface IProductItem {
  productId: number;
  name: string;
  imageUrl: string;
  price: number;
  salePrice: number;
  inStock: boolean;
  productCode: string;
  shortDescription: string | null;
  brandName: string | null;
  sku: string | null;
  barcode: string | null;
  color: string | null;
  size: string | null;
  weight: number | null;
  weightUnit: string | null;
  length: number | null;
  width: number | null;
  height: number | null;
  videoUrl: string | null;
  stock: number;
  discountPercentage: number | null;
  images: string[];
  saleStartDate: string | null;
  saleEndDate: string | null;
}

export interface IGetProductsByCategoryResponse {
  success: boolean;
  message: string;
  data: {
    items: IProductItem[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
  };
}

///// WALLET TOPUP ///

export interface IWalletPaymentResponse {
  transactionReference: string;
  paymentUrl: string;
  amount: number;
  bonusAmount: number;
  walletCredit: number;
}

export interface IWalletTopupPackage {
  id: number;
  name: string;
  description: string;
  topupAmount: number;
  bonusAmount: number;
  walletCredit: number;
}

export type IWalletTopupPackagesResponse = IWalletTopupPackage[];

export interface IWalletTransaction {
  transactionId: number;
  date: string;
  type: string;
  credit: number;
  debit: number;
  balance: number;
  remarks: string;
  referenceNumber: string;
}

export type WalletTransactionResponse = IWalletTransaction[];

export interface IWalletSummary {
  balance: number;
  lifetimeCredited: number;
  lifetimeDebited: number;
}
////// SUBSCRIPTION //

export interface ISubscriptionListItem {
  id: number;
  productVariantId: number;
  productName: string;
  variantName: string;
  imageUrl: string;
  quantity: number;
  billingCycle: number;
  interval: number;
  nextBillingDate: string;
  status: string;
  autoRenew: boolean;
}

// API response type
export type IMySubscriptionListResponse = ISubscriptionListItem[];

export interface ICustomerSubscriptionDashboardSummary {
  activeSubscriptions: number;
  pausedSubscriptions: number;
  cancelledSubscriptions: number;
  nextDeliveryDate: string | null;
  nextDeliveryCount: number;
  failedRenewals: number;
  estimatedUpcomingAmount: number;
  upcomingSubscriptions: IUpcomingSubscription[];
  dueTodayCount: number;
}

export interface IUpcomingSubscription {
  subscriptionId: number;
  productVariantId: number;
  productName: string;
  variantName: string;
  quantity: number;
  nextBillingDate: string;
  estimatedAmount: number;
  status: number;
}

export interface ICustomerSubscriptionDetailsResponse {
  startDate: string;
  cancelledOn: string | null;
  renewals: ICustomerSubscriptionRenewal[];

  id: number;
  productVariantId: number;
  productName: string;
  variantName: string;
  imageUrl: string;

  quantity: number;
  billingCycle: number;
  interval: number;
  nextBillingDate: string;
  status: string;
  autoRenew: boolean;
}

export interface ICustomerSubscriptionRenewal {
  sequenceNumber: number;
  billingDate: string;
  amount: number;
  paymentSucceeded: boolean;
  paymentReference: string | null;
}

export interface ISubscriptionPriceSummary {
  subscriptionId: number;
  productName: string;
  variantName: string;
  imageUrl: string;
  quantity: number;
  nextBillingDate: string;

  unitPrice: number;
  discountPercent: number;
  discountAmount: number;
  subscriptionPrice: number;
  subTotal: number;
  deliveryFee: number;
  taxAmount: number;
  totalAmount: number;
}

////// Customer Orders Response //

export interface ICustomerOrder {
  orderId: number;
  orderNumber: string;
  orderDate: string;

  displayStatus: string;
  statusMessage: string;

  totalAmount: number;
  currency: string;

  totalItems: number;
  moreItemsCount: number;

  hasPendingRevision: boolean;
  paymentRequired: boolean;
  additionalPayment: number;

  actionExpiresOn: string | null;
  remainingMinutes: number;

  refundPending: boolean;
  refundAmount: number;

  canCancelOrder: boolean;
  canTrack: boolean;
  canReview: boolean;

  productCount: number;
  petCount: number;
  serviceCount: number;

  primaryItemType: string;
  primaryItemName: string;

  thumbnailImage: string | null;

  primaryAction: string;
}

export interface IGetCustomerOrdersResponse {
  totalRecords: number;
  page: number;
  pageSize: number;
  orders: ICustomerOrder[];
}

////// Customer Order Details Response //////

export interface ICustomerOrderDetailsHeader {
  orderId: number;
  orderNumber: string;
  orderStatus: string;
  paymentStatus: string;
  orderDate: string;
  estimatedDeliveryDate: string | null;
  totalAmount: number;
  currency: string;
}

export interface ICustomerOrderDetailsCustomer {
  customerId: number;
  name: string;
  mobile: string | null;
  email: string;
}

export interface ICustomerOrderDetailsAddress {
  fullName: string;
  phoneNumber: string;
  addressLine1: string;
  addressLine2: string | null;
  city: string;
  state: string;
  country: string;
  postalCode: string;
}

export interface ICustomerOrderDetailsPricing {
  subTotal: number;
  discount: number;
  shipping: number;
  tax: number;
  donation: number;
  rewardPointDiscount: number;
  walletAmountUsed: number;
  total: number;
  productTotal?:number;
  couponCode?:string;
  couponDiscount:number;
  deliveryFee:number;
  vatAmount:number;
  platformFee:number;
  smallOrderFee?:number;
  totalAmount?:number;
  gatewayAmount?:number;
  rewardPointsEarned?:number
  rewardPointsUsed?:number
  additionalPaymentAmount?:number,
  refundedAmount?:number
  remainingAmount?:number | 0
  savedAmount?:number | 0
}

export interface ICustomerOrderDetailsItem {
  orderLineId: number;
  itemType: string;
  entityId: number;
  name: string;
  subtitle: string;
  imageUrl: string | null;
  quantity: number;
  unitPrice: number;
  unitSalePrice: number;
  totalPrice: number;
  isPromotional: boolean;
  isFreeItem: boolean;
  statusMessage: string | null;
  canReview: boolean;
  reviewed: boolean;
  bookingDate: string | null;
  startTime: string | null;
  endTime: string | null;
}

export interface ICustomerOrderDetailsActions {
  canCancelOrder: boolean;
  canCancelItems: boolean;
  canTrackOrder: boolean;
  canDownloadInvoice: boolean;
  canContactSupport: boolean;
  canReview: boolean;
  canRespondToRevision: boolean;
  canPayAdditionalAmount: boolean;
}

export interface IGetCustomerOrderDetailsResponse {
  header: ICustomerOrderDetailsHeader;
  customer: ICustomerOrderDetailsCustomer;
  address: ICustomerOrderDetailsAddress;
  pricing: ICustomerOrderDetailsPricing;
  items: ICustomerOrderDetailsItem[];

  // TODO: Replace any with actual Revision interface
  // when backend returns revision data.
  revision: any | null;

  // TODO: Replace any with actual Review interface
  // when backend returns review data.
  review: any | null;

  // TODO: Replace any with actual Refund interface
  // when backend returns refund data.
  refund: any | null;

  // TODO: Replace any with actual Tracking interface
  // when backend returns tracking data.
  tracking: any | null;

  // TODO: Add actual Timeline interface
  // when backend returns timeline data.
  timeline: any[];

  actions: ICustomerOrderDetailsActions;
  currentRevision: ICurrentRevision;
}
export interface ICurrentRevision {
  revisionId: number;
  revisionNo: number;
  status: string;
  paymentStatus: string;
  remarks: string;
  originalTotal: number;
  revisedTotal: number;
  differenceAmount: number;
  refundAmount: number;
  additionalPayment: number;
  paymentRequired: boolean;
  expiresOn: string | null;
  isExpired: boolean;
  remainingSeconds: number;
  changes: IRevisionChange[];
  canAccept: boolean;
  canReject: boolean;
}

export interface IRevisionChange {
  targetType: "Product" | "Pet" | "Service";
  changeType: string;
  reason: string;
  originalItem: IRevisionItem;
  replacementItems: IRevisionItem[];
}

export interface IRevisionItem {
  orderItemId: number;
  productId: number;
  productVariantId: number;
  name: string;
  subtitle: string;
  imageUrl: string | null;
  quantity: number;
  unitSalePrice: number;
  totalPrice: number;
  bookingDate: string | null;
  startTime: string | null;
  endTime: string | null;
  billingCycle: string | null;
  billingInterval: string | null;
  orderedQuantity: number;
  remainingQuantity: number;
  replacementQuantity: number;
  removedQuantity: number;
}

export interface CreatePaymentSessionResponse {
  success: boolean;
  data: PaymentSessionData;
}
export interface CompleteInternalPaymentResponse {
  transactionReference: string;
  orderId: number;
}

export interface PaymentSessionData {
  success: boolean;
  paymentUrl: string;
  transactionReference: string;
  message: string;
}

//////  my bookings ///

export interface IMyBookingsResponse {
  bookingId: number;
  bookingNumber: string;
  serviceName: string;
  packageName: string;
  petName: string;
  bookingDate: string; // YYYY-MM-DD
  startTime: string; // HH:mm:ss
  endTime: string; // HH:mm:ss
  status: string;
  paymentStatus: string;
  finalPrice: number;
  employeeName: string | null;
  serviceImage: string | null;
  durationMinutes: number;
  serviceType: string;
  cancelReason: string | null;
  confirmedOn: string | null; // ISO DateTime
  completedOn: string | null; // ISO DateTime
  cancelledOn: string | null; // ISO DateTime
}
export interface IGetBookingDetailsById {
  bookingId: number;
  bookingNumber: string;
  serviceName: string;
  serviceType: string;
  packageName: string;
  pricingLabel: string;
  petName: string;
  petType: string;
  petBreed: string;
  petSize: string;
  bookingDate: string; // YYYY-MM-DD
  startTime: string; // HH:mm:ss
  endTime: string; // HH:mm:ss
  durationMinutes: number;
  finalPrice: number;
  status: string;
  paymentStatus: string;
  paymentMethod: string;
  employeeName: string | null;
  notes: string;
  cancelReason: string | null;
  confirmedOn: string | null; // ISO DateTime
  completedOn: string | null; // ISO DateTime
  cancelledOn: string | null; // ISO DateTime
  serviceDataJson: string;
  history: BookingHistoryItem[];
}

export interface BookingHistoryItem {
  action: string;
  remarks: string;
  oldStatus: string | null;
  newStatus: string;
  oldBookingDate: string | null;
  newBookingDate: string;
  oldStartTime: string | null;
  newStartTime: string;
  oldEndTime: string | null;
  newEndTime: string;
  createdOn: string; // ISO DateTime
}

export interface BookingSlot {
  startTime: string; // HH:mm:ss
  endTime: string; // HH:mm:ss
  isAvailable: boolean;
  remainingCapacity: number;
  bookedCount: number;
  occupiedCount: number;
  capacity: number;
}


export interface ICustomerRatingResponse{
message:string
}


/////// pets filters ///


export interface IPetsCategory {
  id: number;
  name: string;
  slug: string;
  parentId: number;
  level: number;
  count: number;
  children: string[];
}

export interface IPetsBreed {
  id: number;
  name: string;
  count: number;
}

export interface IPetsGender {
  id: number;
  name: string;
  count: number;
}

export interface IPetType {
  id: number;
  name: string;
  count: number;
}

export interface IPetStatus {
  id: number;
  name: string;
  count: number;
}

export interface IPetTag {
  id: number;
  name: string;
  count: number;
}

export interface IPriceRange {
  minPrice: number;
  maxPrice: number;
}

export interface IFilterResponse {
  categories: IPetsCategory[];
  breeds: IPetsBreed[];
  genders: IPetsGender[];
  petTypes: IPetType[];
  petStatuses: IPetStatus[];
  tags: IPetTag[];
  priceRange: IPriceRange;
}


export interface IPetCategory {
  id: number;
  name: string;
  slug: string;
  parentId: number;
  level: number;
}

export interface IPetItem {
  petId: number;
  petCode: string;
  petName: string;
  categories: IPetCategory[];
  breed: string;
  price: number;
  salePrice: number;
  bookPrice: number;
  productImage: string;
  images: string[];
  age: string;
  gender: string;
  tag: string;
  petType: string;
  petStatus: string;
  color: string;
  size: string;
  weight: number;
  isVaccinated: boolean;
  vaccinationDetails: string;
  isKCIRegistered: boolean;
  isFeatured: boolean;
  createdOn: string;
}

export interface IPetSearchResponse {
  items: IPetItem[];
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
  relatedPets: IPetItem[];
}






///////   REWARDS ///

export interface IRewardPointsResponse {
  availablePoints: number;
  lifetimeEarned: number;
  lifetimeRedeemed: number;
  lastEarnedOn: string;
  lastRedeemedOn: string;
  totalTransactions: number;
  transactions: IRewardTransaction[];
}

export interface IRewardTransaction {
  transactionId: number;
  points: number;
  balanceBefore: number;
  balanceAfter: number;
  transactionType: string;
  status: string;
  referenceNumber: string;
  remarks: string;
  createdOn: string;
}

// ============================================================
// Interfaces
// ============================================================

export interface ReferralUser {
  userId: number;
  customerName: string;
  profileImageUrl?: string | null;
  joinedOn: string;
  isFirstOrderCompleted: boolean;
  firstOrderAmount: number;
  referralBonusEarned: boolean;
  referralBonusAmount: number;
  status: string;
}

export interface MyReferralResponse {
  referralCode: string;
  referralLink: string;
  registrationBonus: number;
  firstOrderBonus: number;
  totalReferralBonusEarned: number;
  totalReferredUsers: number;
  completedReferrals: number;
  pendingReferrals: number;
  referrals: ReferralUser[];
}

// Matches the backend response structure
export interface MyReferralApiResponse {
  value?: {
    success: boolean;
    message: string;
    data: MyReferralResponse;
  };
  success?: boolean;
  message?: string;
  data?: MyReferralResponse;
  statusCode?: number;
}

export interface IContactUsDetails{
 phoneNumber:string;
 whatsAppNumber:string ;
 email:string
}

export interface IVideo {
  id: number;
  type: "Product" | "Pet";
  petSellType:string;
  name: string;
  videoUrl: string;
  thumbnailUrl: string;
  imageUrl: string;
  price: number;
  salePrice: number | null;
  discountPercentage: number | null;
  saleStartDate: string | null;
  saleEndDate: string | null;
  stock: number | null;
  inStock: boolean;
  petStatus:PetStatus
}

export interface IVideosResponse {
  items: IVideo[];
  page: number;
  pageSize: number;
  hasMore: boolean;
}
